// extracted by mini-css-extract-plugin
module.exports = {"toggle":"Toggle_toggle__2zmhC","toggle-icon":"Toggle_toggle-icon__1cvht","toggle-button":"Toggle_toggle-button__2vAjf"};